import { Star } from "lucide-react";
import { cn } from "@/lib/cn";

/** Estrela de favoritar dentro de um item clicável — não seleciona o item. Sem favorito, só aparece
 *  ao passar o mouse (o item pai precisa da classe `group`). */
export function EstrelaDeFavorito({
  ativo,
  onAlternar,
  className,
}: {
  ativo: boolean;
  onAlternar: () => void;
  className?: string;
}) {
  return (
    <button
      type="button"
      aria-label={ativo ? "Remover dos favoritos" : "Favoritar"}
      title={ativo ? "Remover dos favoritos" : "Favoritar"}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onAlternar();
      }}
      className={cn(
        "inline-flex h-5 w-5 shrink-0 items-center justify-center rounded transition-opacity",
        ativo
          ? "text-amber-500 opacity-100"
          : "text-zinc-400 opacity-0 hover:text-amber-500 focus-visible:opacity-100 group-hover:opacity-100 max-md:opacity-40",
        className,
      )}
    >
      <Star className="h-3 w-3" fill={ativo ? "currentColor" : "none"} strokeWidth={2.2} />
    </button>
  );
}
